module.exports = __webpack_public_path__ + "img/finish-formation.d395149b.svg";